import { Component } from '@angular/core';
import { Browser } from '@capacitor/browser';
import { Observable } from 'rxjs';
import { EnodeService } from 'src/app/services/enode/enode.service';
import { LinkResponse } from 'src/app/services/enode/enode.types';
import LinkUI from 'src/app';
import { Platform } from '@ionic/angular';

@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrls: ['./onboarding.component.scss']
})
export class OnboardingComponent {
  linkVehicle$: Observable<LinkResponse>;

  isLoading = false;
  code: string;
  errMsg: string;

  constructor(private _enodeService: EnodeService, public platform: Platform) {
    this.linkVehicle$ = this._enodeService.linkVehicle();
  }

  linkVehicle() {
    // Har trykket link. Må vente på svar
    this.linkVehicle$.subscribe({
      next: async (res) => {
        this.isLoading = true;
        if (this.platform.is('capacitor')) {
          LinkUI.show({ token: res.linkToken }).then((res) => {
            const { code, errMsg } = res;
            switch (code) {
              case 'success':
                setTimeout(() => {
                  this.isLoading = false;
                }, 60000);
                break;
              case 'cancelledByUser':
                this.isLoading = false;
                break;
              default:
                this.isLoading = false;
                break;
            }
          });
        } else {
          await Browser.open({
            url: res.linkUrl
          });
          setTimeout(() => {
            this.isLoading = false;
          }, 60000);
        }
      }
    });
  }
}
